import Modal from '@components/Modals/Modal.js';
import { UIDiv, UIText } from '@ui';

export default class RolesModal extends Modal {
  constructor() {
    super(i18next.t('modal.rolesModal.title'), {
      showCancel: false,
      showConfirm: false,
      showCloseIcon: true,
      modalContentClass: '!w-fit',
    });
  }

  createModal() {
    const modal = super.createModal();
    const table = new UIDiv().setClass('divide-y divide-gray-200');
    const headerRow = new UIDiv().setClass('grid grid-cols-[100px_1fr] py-2');
    headerRow.add(
      new UIText(i18next.t('modal.rolesModal.role')).setClass('font-medium'),
      new UIText(i18next.t('modal.rolesModal.description')).setClass(
        'font-medium',
      ),
    );

    const roles = [
      {
        role: i18next.t('role.admin'),
        description: i18next.t('modal.rolesModal.adminDescription'),
      },
      {
        role: i18next.t('role.manager'),
        description: i18next.t('modal.rolesModal.managerDescription'),
      },
      {
        role: i18next.t('role.member'),
        description: i18next.t('modal.rolesModal.memberDescription'),
      },
    ];

    const roleRows = roles.map(({ role, description }) => {
      const row = new UIDiv().setClass('grid grid-cols-[100px_1fr] py-3');
      const roleCell = new UIDiv().setClass('flex items-center gap-2');
      roleCell.add(new UIText(role));
      row.add(roleCell, new UIText(description).setClass('text-gray-600'));
      return row;
    });

    table.add(headerRow, ...roleRows);
    this.contentContainer.add(table);

    return modal;
  }
}
